
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

//draft-Editor
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from "html-to-draftjs";

//context 
import { usePagesState, TermsAndcondition, TermsEdit } from "../../context/PagesContext";
import { Button, Box } from "@material-ui/core";

//global css
import "../../static/css/global.css";


//Terms and Conditions Page
function EditTerms() {
  const context = usePagesState();

  const [editorstate, seteditorstate] = useState(() => EditorState.createEmpty())
  const [Convertedcontent, setConvertedcontent] = useState(null);
  const [disable, setdisable] = useState(true);

  useEffect(() => {
    TermsAndcondition(context.setTerms)
  }, []);


  useEffect(() => {
    if (context.Terms.Terms.data && context.Terms.Terms.data.content) {


      let blocksFromHtml = htmlToDraft(context.Terms.Terms.data.content);
      let { contentBlocks, entityMap } = blocksFromHtml;
      let contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
      let editorState = EditorState.createWithContent(contentState);
      seteditorstate(editorState);
    }
  }, [context.Terms.Terms.data])

  const handleEditorChange = (state) => {
    seteditorstate(state);
    convertContentToHTML();
    setdisable(false)

  }

  //convert draft to html 
  const convertContentToHTML = () => {
    let currentContentAsHTML = draftToHtml(convertToRaw(editorstate.getCurrentContent()))
    setConvertedcontent(currentContentAsHTML);
  }

  const HandleSubmit = () => {
    const reqData = {
      id: 5,
      content: Convertedcontent,
    }
    TermsEdit(context.setTermsEdit, reqData);
  }

  return (<>
    <div className="RichText">
      <Editor
        editorState={editorstate}
        onEditorStateChange={handleEditorChange}
        wrapperClassName="wrapper-class"
        editorClassName="editor-class"
        toolbarClassName="toolbar-class" />
    </div>

    <div className="submit_button">
      <Box component="span" m={1}
        display="flex"
        justifyContent="flex-end"
        alignItems="flex-end">

        <Button variant="contained" color="primary" onClick={HandleSubmit} disabled={disable} > Update </Button>

      </Box>
    </div>
  </>
  );
}

export default withRouter(EditTerms);
